export const SUPPORTED_LANGUAGES = ['sk', 'cs', 'en', 'de', 'pl'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_STORAGE_KEY = 'kf-language';

export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  sk: 'SK',
  cs: 'CZ',
  en: 'EN',
  de: 'DE',
  pl: 'PL',
};

export const LANGUAGE_NAMES: Record<AppLanguage, string> = {
  sk: 'Slovenčina',
  cs: 'Čeština',
  en: 'English',
  de: 'Deutsch',
  pl: 'Polski',
};

export function normalizeLanguage(language?: string | null): AppLanguage {
  const lower = language?.toLowerCase() ?? 'sk';

  if (lower.startsWith('sk')) return 'sk';
  if (lower.startsWith('cs') || lower.startsWith('cz')) return 'cs';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('de')) return 'de';
  if (lower.startsWith('pl')) return 'pl';

  return 'sk';
}
